<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <!-- <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button> -->
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <!-- <div class="col mb-3">
                            <TheInputText title="ID" placeholder="Tìm theo ID" :initialValue="sValue_ID"
                                v-model="sValue_ID" :isRequire=false :key="tempKey" @onChange="v => handlePageChange(1)" />
                        </div> -->
                        <div class="col mb-3">
                            <TheInputText title="Tên" placeholder="Tìm theo tên" :initialValue="sValue_TEN"
                                v-model="sValue_TEN" :isRequire=false :key="tempKey" @onChange="v => handlePageChange(1)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Phân hệ" :options="category_PHANHE" :initialValue="sValue_PHANHE"
                                :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(v) => searchChangePhanHe(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Nhóm quyền" :options="category_sNHOMQUYEN" :initialValue="sValue_NHOMQUYEN"
                                :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(v) => searchChangeNhomQuyen(v)" />
                        </div>
                        <div class="col mb-3">
                            <div class="form-group">
                                <label>
                                    <span>Hiển thị trên cổng</span>
                                </label>
                                <select id="enabled_sOptions" class="form-control select2bs4" style="width: 100%">
                                    <option :value=null>--- Tất cả ---</option>
                                    <option :value=true>Bật</option>
                                    <option :value=false>Tắt</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="sType_List == 1">Danh sách hiện hành</b>
                        <b v-if="sType_List == 2">Danh sách đã xóa</b>
                    </h3>
                    <div class="card-tools">
                        <button v-if="sType_List == '2'" type="button" class="btn btn-tool"
                            title="Chuyển sang danh sách hiện hành" @click="changeCurrentTypeSearch()">
                            <i class="far fa-list-alt" style="color: #28a745;"></i>
                        </button>

                        <button v-if="sType_List == '1'" type="button" class="btn btn-tool"
                            title="Chuyển sang danh sách đã xóa" @click="changeCurrentTypeSearch()">
                            <i class="fas fa-list-alt" style="color: #df132e;"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-toggle="dropdown"
                            v-bind:title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <a v-if="sType_List == '2'" class="dropdown-item text-green" href="#"
                                        @click="confirmList('restore')" :title="$t('labels.restore')"><i
                                            class="fas fa-undo"></i>&nbsp;&nbsp;{{ $t('labels.restore') }}</a>
                                    <div class="dropdown-d ivider"></div>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-red" href="#"
                                        @click="confirmList('delete')" :title="$t('labels.delete')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('labels.delete')
                                        }}</a>
                                    <a v-if="sType_List == '2'" class="dropdown-item text-red" href="#"
                                        @click="confirmList('deleteReal')" :title="$t('labels.deleteReal')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('labels.deleteReal')
                                        }}</a>
                                    <div class="dropdown-d ivider"></div>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-green" href="#" @click="confirmList('onEnabled')"
                                        title="Bật hiển thị trên Cổng"><i class="fas fa-toggle-on"></i>&nbsp;&nbsp;
                                        Bật hiển thị trên cổng</a>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-red" href="#" @click="confirmList('offEnabled')"
                                        title="Ẩn hiển thị trên Cổng"><i class="fas fa-toggle-off"></i>&nbsp;&nbsp;
                                        Tắt hiển thị trên cổng</a>
                                </div>
                            </div>
                        </button>
                        <button type="button" class="btn btn-tool" @click="detail(null, 'create')"
                            v-bind:title="$t('labels.create')">
                            <i class="fas fa-plus"></i>
                        </button>
                        <!-- <button type="button" class="btn btn-tool" @click="getData" v-bind:title="$t('labels.reload')">
                    </button> -->
                        <!-- <button type="button" class="btn btn-tool" data-card-widget="collapse"
                        v-bind:title="$t('labels.collapse')">
                        <i class="fas fa-minus"></i>
                    </button> -->
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>

                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th class="col10"></th>
                                    <th class="col50">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                @click="selectAllRows($event)">
                                            <label for="checkboxAll" class="custom-control-label"></label>
                                        </div>
                                    </th>
                                    <th class="col10 cursor" @click="handleSortChange('id')">
                                        ID
                                        <span v-if="(orderDesc == false && sortBy == 'id')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'id')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>


                                    <th class="col50 cursor" @click="handleSortChange('ten')">
                                        Tên
                                        <span v-if="(orderDesc == false && sortBy == 'ten')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'ten')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('appName')">
                                        Phân hệ
                                        <span v-if="(orderDesc == false && sortBy == 'appName')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'appName')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('tenRolesGroup')">
                                        Nhóm quyền
                                        <span v-if="(orderDesc == false && sortBy == 'tenRolesGroup')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'tenRolesGroup')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col100">
                                        Mô tả
                                    </th>
                                    <th class="col100">
                                        Ghi chú
                                    </th>
                                    <th class="col10 cursor" @click="handleSortChange('stt')">
                                        STT
                                        <span v-if="(orderDesc == false && sortBy == 'stt')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'stt')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50">Hiển thị trên cổng</th>
                                    <th class="col50"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td></td>
                                    <td @click="selectRow(item.id)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <span v-if="(csList.includes(item.id))" aria-hidden="true"
                                            class="text-primary">&check;</span>
                                        <span v-else aria-hidden="true">&nbsp;</span>
                                    </td>
                                    <td>{{ item.id }}</td>
                                    <td>{{ item.ten }}</td>
                                    <td>{{ item.appName }}</td>
                                    <td>{{ item.tenRolesGroup }}</td>
                                    <td>{{ item.moTa }}</td>
                                    <td>{{ item.ghiChu }}</td>
                                    <td>{{ item.stt }}</td>
                                    <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" :disabled="sType_List == 2"
                                                :id="'item' + item.id" v-model="item.enabledDisplay"
                                                v-on:click="openConfirmEnabledChange(item)">
                                            <label class="custom-control-label"
                                                :for="'item' + item.id"></label>
                                        </div>
                                    </td>
                                    <td>
                                        <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="detail(item, 'detail')" title="Xem chi tiết">
                                            <i class="fas fa-eye text-secondary"></i>
                                        </button>&nbsp;
                                        <span v-if="sType_List == 1">
                                            <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                                v-on:click="detail(item, 'update')" title="Cập nhật">
                                                <i class="fas fa-pencil-alt"></i>
                                            </button>&nbsp;
                                        </span>
                                        <button type="button" size="sm" class="btn btn-outline-danger btn-xs"
                                            v-on:click="detail(item, 'delete')" title="Xóa">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>&nbsp;
                                        <button v-if="sType_List == 2" type="button" size="sm"
                                            class="btn btn-outline-warning btn-xs" v-on:click="detail(item, 'restore')" title="Khôi phục" >
                                            <i class="fas fa-undo"></i>
                                        </button>&nbsp;

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="insUpdModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-primary">{{ title }}</h4>
                            <button type="button" class="close" aria-label="Close" @click="hideModal()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Tên" placeholder="Nhập tên" :initialValue="model.ten"
                                        v-model="model.ten" :error="errors.ten" :isReadOnly="isReadonly" :isRequire=true
                                        :isMultipleLine="false" :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Nhóm quyền" :options="category_cNHOMQUYEN" :dropdownParent="modalName"
                                        :initialValue="model.rolesGroupId" :error="errors.rolesGroupId" :isMultiple="false"
                                        :isReadOnly="isReadonly" :isAllowClear="true" :isRequire="true"
                                        @onChange="(e) => { model.rolesGroupId = e }" :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Mô tả" placeholder="Nhập mô tả" :initialValue="model.moTa"
                                        v-model="model.moTa" :error="errors.moTa" :isReadOnly="isReadonly"
                                        :isRequire=false :isMultipleLine="true" :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Ghi chú" placeholder="Nhập ghi chú"
                                        :initialValue="model.ghiChu" v-model="model.ghiChu" :error="errors.ghiChu"
                                        :isReadOnly="isReadonly" :isRequire=false :isMultipleLine="true"
                                        :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="STT" placeholder="Nhập STT" :initialValue="model.stt"
                                        v-model="model.stt" :error="errors.stt" :isReadOnly="isReadonly" :isRequire=true
                                        :isMultipleLine="false" :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <label>Hiển thị trên cổng</label>
                                </div>
                                <div class="col-md-12">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="enabled-checkbox" :disabled="isReadonly"
                                            v-model="model.enabledDisplay">
                                        <label class="custom-control-label" for="enabled-checkbox"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="hideModal()">&nbsp;Đóng</button>

                            <button type="button" class="pull-right" :class="styleButton" v-if="code != 'detail'"
                                @click="onSubmit();">&nbsp;{{ title }}</button>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-success">Chi tiết</h4>
                            <button type="button" class="close" aria-label="Close" @click="hidePopupDetail">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row" v-if="modelRec">
                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                                    <p class="text-sm">ID
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.id }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Tên
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ten }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Phân hệ
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.appName }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Nhóm quyền
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenRolesGroup }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">STT
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.stt }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Mô tả
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.moTa }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Ghi chú
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ghiChu }}&nbsp;</b>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="modal fade" id="confirmcsListModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-success">{{ csList_Title }}</h4>
                            <button type="button" class="close" aria-label="Close" @click="hidePopupconfirmcsListModal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <p class="text-sm">Bạn có chắc chắn <b>{{ csList_Title }}</b> các dữ liệu đã chọn?</p>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="hidePopupconfirmcsListModal">&nbsp;{{
                                    $t('buttons.close') }}</button>
                            <button type="button" class="btn btn-outline-danger pull-right"
                                @click=" onSubmitList();">&nbsp;{{ csList_Title }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="enabledConfirmModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-danger" style="text-transform:uppercase;">XÁC NHẬN</h4>
                            <button type="button" class="close" aria-label="Close" @click="closeConfirmEnabledChange()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <label>Bạn có chắc chắn muốn thay đổi hiển thị trên cổng?</label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input
                                    class="custom-control-input custom-control-input-danger custom-control-input-outline"
                                    type="checkbox" v-model="checkEnable_Memo" checked="" id="checkboxMemo">
                                <label for="checkboxMemo" class="custom-control-label">Ghi nhớ không hiển thị lại xác
                                    nhận</label>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="closeConfirmEnabledChange()">&nbsp;Thoát</button>
                            <button type="button" class="btn btn-outline-danger pull-right"
                                @click=" updateEnabled(2);">&nbsp;Xác nhận</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>


</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';
// import TheDatePicker from '@/components/shareComponents/TheDatePicker.vue';
// import TheInputTextSelect from '@/components/shareComponents/TheInputTextSelect.vue';
// import TheFilePicker from '@/components/shareComponents/TheFilePicker.vue';

import { quyenModel } from '@/models/quantri/quyen.model'

export default {
    name: "TheQuyenQT",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
        // TheDatePicker,
        // TheInputTextSelect,
        // TheFilePicker,
    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,

            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadonly: null,

            modelRec: quyenModel.newModel(),
            model: quyenModel.newFEModel(),
            errors: quyenModel.errors(),

            sValue_ID: null,
            sValue_TEN: null,
            sValue_PHANHE: null,
            sValue_NHOMQUYEN: null,
            sValue_SORT: null,
            sValue_ENABLED: null,

            cEnable_Value: null,
            checkEnable_Memo: false,

            category_PHANHE: [],
            category_sNHOMQUYEN: [],
            category_cNHOMQUYEN: [],

            csList: [],
            csList_Title: "",
            csList_Code: null,
            sType_List: 1,

            tempKey: common.randomString(10)
        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber'],),
        //...mapActions('adjustData', ['formatDateShow', 'fromDatetoString']),
        ...mapActions('quyenQT', ['getPagingQuyenQT', 'getDetailQuyenQT', 'checkExistQuyenQT', 'createQuyenQT', 'updateQuyenQT', 'deleteQuyenQT', 'restoreQuyenQT', 'handleListQuyenQT', 'setEnabledQuyenQT']),
        ...mapActions('phanHeQT', ['getBasicPhanHeQT']),
        ...mapActions('nhomQuyenQT', ['getBasicNhomQuyenQT']),
        async setup() {
            let header = 'Quản trị quyền'
            this.setupHeader({ header })
        },

        async initialize() {
            // $(".select2bs4").select2({
            //     theme: "bootstrap4",
            // })
            // $('#my-colorpicker').colorpicker()
            // $('#timepicker').datetimepicker({ use24hours: true, format: 'HH:mm' })

            $('#enabled_sOptions').on('change', e => {
                let a = e.target.value
                let returnValue = null
                switch (a) {
                    case "true":
                        returnValue = true
                        break
                    case "false":
                        returnValue = false
                        break
                    default:
                        returnValue = null
                }
                this.sValue_ENABLED = returnValue
                this.handlePageChange(1)
            });
        },

        async showModal() {
            $('#insUpdModal').modal('show')

        },
        async hideModal() {
            $('#insUpdModal').modal('hide')
            // await this.getData()
        },

        async showPopupDetail() {
            $('#detailModal').modal('show')
        },
        async hidePopupDetail() {
            $('#detailModal').modal('hide')
        },
        async showPopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('show')
        },
        async hidePopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('hide')
            //await this.getData()
        },
        async showEnabledConfirmModal() {
            $('#enabledConfirmModal').modal('show')
        },
        async hideEnabledConfirmModal() {
            $('#enabledConfirmModal').modal('hide')
        },

        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.sValue_SORT = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
            await this.getData()
        },

        async changeCurrentTypeSearch() {
            if (this.sType_List == 2) this.sType_List = 1
            else if (this.sType_List == 1) this.sType_List = 2
            await this.handlePageChange(1)
        },

        async selectRow(id) {
            if (this.csList.includes(id)) {
                this.csList.splice(this.csList.indexOf(id), 1)
            }
            else {
                this.csList.push(id)
            }
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList = this.items.map((item) => {
                    return item.id
                })
            }
            else {
                this.csList = []
            }
        },

        async openConfirmEnabledChange(item) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Value = item
                await this.showEnabledConfirmModal()
            }
            else {
                this.cEnable_Value = item
                this.updateEnabled(1)

            }

        },

        async updateEnabled(from) {
            let model = {
                id: this.cEnable_Value.id,
                enabled: from == 1 ? !this.cEnable_Value.enabledDisplay : this.cEnable_Value.enabledDisplay
            }
            await this.setEnabledQuyenQT({ model: model }).then(resp => {
                if (resp) {
                    this.hideEnabledConfirmModal()
                }
                else {
                    this.hideEnabledConfirmModal()
                }
            });
        },

                async closeConfirmEnabledChange() {
            this.cEnable_Value.enabledDisplay = !this.cEnable_Value.enabledDisplay
            $('#item' + this.cEnable_Value.id).prop('checked', this.cEnable_Value.enabledDisplay);
            await this.hideEnabledConfirmModal()
        },
        async searchChangePhanHe(e) {
            this.sValue_PHANHE = e == "" ? null : e
            this.sValue_NHOMQUYEN = null
            if(this.sValue_PHANHE) this.category_sNHOMQUYEN = await this.getCategory_NHOMQUYEN(this.sValue_PHANHE)
            else this.category_sNHOMQUYEN = []
            this.handlePageChange(1)
        },
        async searchChangeNhomQuyen(e) {
            this.sValue_NHOMQUYEN = e == "" ? null : e
            this.handlePageChange(1)
        },
        async getData() {
            this.isBusy = true
            this.csList = []
            let params = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                ten: this.sValue_TEN == "" ? null : this.sValue_TEN,
                appId: this.sValue_PHANHE,
                rolesGroupId: this.sValue_NHOMQUYEN,
                sort: this.sValue_SORT,
                enabled: this.sValue_ENABLED,
            }
            await this.getPagingQuyenQT({ params: params, type: this.sType_List }).then(res => {
                // List data
                this.items = res.data
                if (this.items) {
                    for (let i = 0; i < this.items.length; i++) {
                        this.items[i].enabledDisplay = this.items[i].enabled == 1 ? true : false
                    }
                }

                // // Total row
                this.totalRow = res.totalRow
                // // Number show
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                // // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },

        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            if (this.code == 'delete' && this.sType_List == 2) this.title = this.$t('labels.deleteReal')
            this.styleButton = this.$t('labels.styleButton' + code)
            this.styleTitle = this.$t('labels.styleTitle' + code)
            this.errors = quyenModel.errors()

            if (this.code == 'update' || this.code == 'delete' || this.code == 'restore') {
                let params = {
                    id: item.id
                }
                let resp = await this.getDetailQuyenQT({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = quyenModel.newModel()
                        this.modelRec = resp
                        this.model = quyenModel.parseModeltoFEModel(this.modelRec)
                        //this.triggerDetail()
                        //this.isReadonly = (code == "create") ? false : true
                    }
                });
                this.isReadonly = (code == "delete" || code == "restore") ? true : false
                this.tempKey = common.randomString(10)
                await this.showModal()

            }
            else if (this.code == 'detail') {
                let params = {
                    id: item.id
                }
                await this.getDetailQuyenQT({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = quyenModel.newModel()
                        this.modelRec = resp
                    }
                });
                this.tempKey = common.randomString(10)
                this.showPopupDetail()
            }
            else {

                this.model = quyenModel.newFEModel()
                this.filesUpload = []
                //this.triggerDetail()
                this.isReadonly = (code == "create") ? false : true
                //this.isReadonly = this.isReadonly = (code == "delete") ? true : false
                // show popup
                this.tempKey = common.randomString(10)
                this.showModal()
            }
        },

        async validate(model) {
            let isvalid = true
            this.errors = quyenModel.errors()
            if (!await this.validateRequired(model.ten)) {
                this.errors.ten = "Nhập tên"
                isvalid = false
            }
            else if (this.code == "update" && this.modelRec.ten != model.ten) {
                if (await this.checkExistName(model.ten)) {
                    this.errors.ten = "Tên này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }
            else if (this.code == "create") {
                if (await this.checkExistName(model.ten)) {
                    this.errors.ten = "Tên này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }

            if (!await this.validateRequired(model.stt)) {
                this.errors.stt = "Nhập số thứ tự"
                isvalid = false
            }
            else if (!await this.validateNumber(model.stt)) {
                this.errors.stt = "Số thứ tự phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateRequired(model.rolesGroupId)) {
                this.errors.rolesGroupId = "Chọn nhóm quyền"
                isvalid = false
            }


            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = quyenModel.newModel()
            if (this.code == "update" || this.code == "delete" || this.code == "restore") sendModel.id = FEmodel.id
            sendModel.ten = FEmodel.ten
            sendModel.moTa = FEmodel.moTa
            sendModel.ghiChu = FEmodel.ghiChu
            sendModel.rolesGroupId = FEmodel.rolesGroupId
            sendModel.stt = FEmodel.stt
            sendModel.enabled = FEmodel.enabledDisplay ? FEmodel.enabledDisplay : false
            return sendModel
        },
        async onSubmit() {
            let code = this.code
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            let params = null
            switch (code) {
                case "create":
                    if (await this.validate(sendModel)) {
                        res = await this.createQuyenQT({ model: sendModel })
                        if (res) {
                            await this.getData()
                            this.hideModal()
                        }
                    }
                    break
                case "update":
                    if (await this.validate(sendModel)) {
                        res = await this.updateQuyenQT({ model: sendModel })
                        if (res) {
                            await this.getData()
                            this.hideModal()
                        }
                    }
                    break
                case "delete":
                    // eslint-disable-next-line
                    params = {
                        id: sendModel.id
                    }
                    res = await this.deleteQuyenQT({ model: params, type: this.sType_List })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                case "deleteReal":
                    // eslint-disable-next-line
                    params = {
                        id: sendModel.id
                    }
                    res = await this.deleteQuyenQT({ model: params, type: this.sType_List })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                case "restore":
                    // eslint-disable-next-line
                    res = await this.restoreQuyenQT({ model: sendModel })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                default:
            }
        },

        async confirmList(code) {
            if (this.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Code = code
                if (code == 'delete') this.csList_Title = "Xóa"
                else if (code == 'deleteReal') this.csList_Title = "Xóa hoàn toàn"
                else if (code == 'restore') this.csList_Title = "Khôi phục"
                else if (code == 'offEnabled') this.csList_Title = "Tắt hiển thị"
                else if (code == 'onEnabled') this.csList_Title = "Bật hiển thị"
                this.showPopupconfirmcsListModal()
            }

        },

        async onSubmitList() {
            let code = this.csList_Code
            let t = null
            let params = {
                listId: this.csList.toString()
            }
            // if(code == "offEnebaled") params.enabled = false
            // else if(code == "onEnebaled") params.enabled = true
            let res = null
            switch (code) {
                case "delete":
                    res = await this.handleListQuyenQT({ model: params, type: 1 })
                    break
                case "deleteReal":
                    res = await this.handleListQuyenQT({ model: params, type: 2 })
                    break
                case "restore":
                    res = await this.handleListQuyenQT({ model: params, type: 3 })
                    break
                case "offEnabled":
                    params.enabled = false
                    res = await this.handleListQuyenQT({ model: params, type: 4 })
                    break
                case "onEnabled":
                    params.enabled = true
                    res = await this.handleListQuyenQT({ model: params, type: 4 })
                    break
                default:
            }
            if (res) {
                await this.getData()
                this.hidePopupconfirmcsListModal()
            }
        },
        async checkExistName(name) {
            let params = {
                ten: name
            }
            let res = await this.checkExistQuyenQT({ params: params })
            return res.data

        },

        async getCategory_PHANHE() {
            let params = {

            }
            let res = await this.getBasicPhanHeQT({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].appId,
                            name: res[i].appName
                        }
                    )
                }
                return handleRes
            }
            return res
        },

        async getCategory_NHOMQUYEN(idPhanHe) {
            let params = {
                appId: idPhanHe
            }
            let res = await this.getBasicNhomQuyenQT({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].rolesGroupId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return res
        },
    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()

        this.category_PHANHE = await this.getCategory_PHANHE()
        this.category_cNHOMQUYEN = await this.getCategory_NHOMQUYEN(null)

        // $('#enabled-checkbox').on('change', e => {
        //     this.model.enabledDisplay = e.target.checked;
        // });
    }


}
</script>
<style></style>